module.exports = __webpack_public_path__ + "static/cov-c1ce9906cc4ad8035fbc8be7f181356a.webp";